import type { Project as FhirProject } from "@medplum/fhirtypes";
import { queryOptions } from "@tanstack/react-query";

import type { Project } from "@/types/medplum";
import { fetchProjects } from "@/apis/medplum";

const fhirProjectToProject = (project: FhirProject): Project | null => {
  if (!project.id) {
    return null;
  }

  return {
    id: project.id,
    name: project.name ?? project.id,
  };
};

/**
 * TanStack query factory: `all*` entries are key-only prefixes of the entry
 * after them, for invalidating that resource for every parameter at once.
 */
export const projectQueries = {
  allSuperAdminProjects: () => ["super-admin-projects"] as const,
  superAdminProjects: (profileId: string | undefined) =>
    queryOptions({
      queryKey: [...projectQueries.allSuperAdminProjects(), profileId],
      queryFn: async () => {
        const fetched = await fetchProjects();
        return fetched
          .map(fhirProjectToProject)
          .filter((project): project is Project => project !== null);
      },
    }),
};
